import styled from "styled-components";
import defaultBg from "../../../assets/images/header.jpg";

export const CustomHeader = styled.header`
  background-image: 
  ${props =>
    !!props.image
      ? `url(${props.image}), url(${defaultBg})`
      : `url(${defaultBg})`
  }
`;



// WEBPACK FOOTER //
// ./src/containers/Menu/Header/styles.js